import moment from 'moment';
import { deliveryConfirmationToReport } from '../../../../../core/models/dashboard/data-utilization-dad.model';

export const deliveryConfirmation = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Confirmación_de_Entrega.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Id.',
        name: 'id',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w130',
        value: (element: deliveryConfirmationToReport) => element.id
      },
      {
        title: 'Compañia',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.companyCode
      },
      {
        title: 'ID nota de venta',
        name: 'saleNoteId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryConfirmationToReport) => element.saleNoteId
      },
      {
        title: 'Id de estado',
        name: 'stateId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.stateId
      },
      {
        title: 'Código tipo de entrega',
        name: 'deliveryTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryConfirmationToReport) => element.deliveryTypeCode
      },
      {
        title: 'Código de tipo de origen',
        name: 'originTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.originTypeCode
      },
      {
        title: 'Último Código de Entidad',
        name: 'lastEntityTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.lastEntityTypeCode
      },
      {
        title: 'Código de tipo de transacción',
        name: 'transactionTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w120',
        value: (element: deliveryConfirmationToReport) => element.transactionTypeCode
      },
      {
        title: 'Confirmación Origen',
        name: 'confirmationOrigin',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.confirmationOrigin
      },
      {
        title: 'Canal',
        name: 'channel',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.channel
      },
      {
        title: 'Estado',
        name: 'state',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.state
      },
      {
        title: 'Fecha de entrega',
        name: 'deliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport)  => moment(element.deliveryDate).format('YYYY-MM-DD')
      },

      {
        title: 'Total',
        name: 'total',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: deliveryConfirmationToReport) => element.total
      }
    ],
    subTable: {}
  };
